export default "__VITE_ASSET__aeLTQE3j__"